export const policySections = [
  { title: 'Загальні положення',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fuga fugiat nobis officiis. Aliquam impedit iste, minima nesciunt quos sequi vero!'
  },
  { title: 'Інформація, яку ми збираємо',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fuga fugiat nobis officiis. Aliquam impedit iste, minima nesciunt quos sequi vero!'
  },
  { title: 'Використання інформації',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fuga fugiat nobis officiis. Aliquam impedit iste, minima nesciunt quos sequi vero!'},
  { title: 'Розкриття інформації',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fuga fugiat nobis officiis. Aliquam impedit iste, minima nesciunt quos sequi vero!'},
  { title: 'Зміни до політики конфіденційності',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fuga fugiat nobis officiis. Aliquam impedit iste, minima nesciunt quos sequi vero!'},
  { title: 'Зв\'яжіться з нами',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fuga fugiat nobis officiis. Aliquam impedit iste, minima nesciunt quos sequi vero!'},

];
